import { Controller } from '@nestjs/common';

@Controller('qualification')
export class QualificationController {}
